var _, jQuery, linkify;

jQuery = require('jquery');

_ = require('underscore');

linkify = require('linkifyjs/html');

exports.statusColor = function(status) {
  switch (status) {
    case 'evaluating':
      return 'warning';
    case 'approved':
      return 'info';
    case 'paid':
      return 'success';
    case 'incomplete':
    case 'rejected':
      return 'danger';
    default:
      return '';
  }
};

exports.pageNumbers = function(numPages, currentPage, options) {
  var i, leftCurrent, leftEdge, page, pages, ref, ref1, ref2, ref3, ref4, rightCurrent, rightEdge;
  options = options != null ? options : {};
  leftEdge = (ref = options.leftEdge) != null ? ref : 2;
  leftCurrent = (ref1 = options.leftCurrent) != null ? ref1 : 2;
  rightCurrent = (ref2 = options.rightCurrent) != null ? ref2 : 5;
  rightEdge = (ref3 = options.rightEdge) != null ? ref3 : 2;
  pages = [];
  for (page = i = 1, ref4 = numPages; 1 <= ref4 ? i <= ref4 : i >= ref4; page = 1 <= ref4 ? ++i : --i) {
    if (page <= leftEdge) {
      pages.push(page);
    } else if (((currentPage - leftCurrent) <= page && page < (currentPage + rightCurrent))) {
      pages.push(page);
    } else if (numPages - rightEdge < page) {
      pages.push(page);
    } else if (pages[pages.length - 1] !== null) {
      pages.push(null);
    }
  }
  return pages;
};

exports.localToUTC = function(date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};

exports.urlize = function(str, limit) {
  if (limit === void 0) {
    limit = 2e308;
  }
  return linkify(str, {
    format: function(value, type) {
      if (type === 'url' && value.length > limit) {
        value = (value.slice(0, limit)) + "...";
      }
      return value;
    }
  });
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
